import { useCallback } from 'react';
import { ReactEditor } from 'slate-react';

function useFocus(editor) {
  const handleBlur = useCallback(() => {
    if (ReactEditor.isFocused(editor)) {
      ReactEditor.deselect(editor);
    }
  }, [editor]);
  return {
    handlers: {
      onBlur: handleBlur
    }
  };
}

export { useFocus };
